import classNames from 'classnames/bind';
import styles from './FaqBreadcrumbs.module.scss';
import { ArrowRight } from '@/components';
import Link from 'next/link';

let cx = classNames.bind(styles);

export function FaqBreadcrumbs({ router, basePath, categories }) {
	let category, search;
	if (router.query.slug[0] !== 'search' && router.query.slug.length > 1) {
		if (categories) {
			category = categories.find((tempCategory) => tempCategory.id.toString() === router.query.slug[0]);
		}
	} else if (router.query.slug[0] === 'search' && router.query.slug.length > 2) {
		search = router.query.slug[1];
	}
	return (
		<div className={cx(['breadcrumbs', 'is-style-heading-eyebrow'])}>
			<Link href={basePath} className={cx(['breadcrumb-link'])}>
				FAQ
			</Link>
			{category && (
				<>
					<span className={cx('category-arrow')}>
						<ArrowRight />
					</span>
					<Link href={`${basePath}/${category.id}`} className={cx(['breadcrumb-link'])}>
						{category.name}
					</Link>
				</>
			)}
			{search && (
				<>
					<span className={cx('category-arrow')}>
						<ArrowRight />
					</span>
					<Link href={`${basePath}/search/${search}`} className={cx(['breadcrumb-link'])}>{`Search for "${search}"`}</Link>
				</>
			)}
		</div>
	);
}
